import { supabase } from "@/integrations/supabase/client";

const SESSION_KEY = "wh_session_id";
const SESSION_START_KEY = "wh_session_start";

function getSessionId(): string {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = (crypto.randomUUID?.() || String(Date.now() + Math.random()));
      sessionStorage.setItem(SESSION_KEY, id);
      sessionStorage.setItem(SESSION_START_KEY, String(Date.now()));
    }
    return id;
  } catch {
    return "unknown";
  }
}

export function getSessionDurationMs(): number {
  try {
    const start = Number(sessionStorage.getItem(SESSION_START_KEY) || "0");
    if (!start) return 0;
    return Date.now() - start;
  } catch {
    return 0;
  }
}

export async function trackEvent(
  event_name: string,
  properties: Record<string, unknown> = {},
): Promise<void> {
  try {
    const session_id = getSessionId();
    const path =
      typeof window !== "undefined" ? window.location.pathname : undefined;
    await supabase.from("analytics_events").insert({
      event_type: event_name,
      metadata: { ...properties, path, session_id },
    });
  } catch {
    // analytics must never break UX
  }
}